import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { TextBox, CheckBox } from 'fw/forms';
import { Label } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import { Address } from 'areas/shared/controls';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class AccountInfoTab extends SetupTab {
    initialForm() {
        return {
            accountName: "",
            desctription: "",
            address: "",
            city: "",
            countryCode: "",
            country: "",
            stateCode: "",
            state: "",
            zip: "",
            active: true,
            rowVersion: null
        }
    }
    privileges() {
        return {
            add: App.hasPrivilege("AdminAccountSetupAdd"),
            edit: App.hasPrivilege("AdminAccountSetupEdit")
        }
    }

    urls() {
        return {
            get: API.Security.url('/accountSetup/getAccountInfo'),
            save: API.Security.url('/accountSetup/saveAccountInfo')
        }
    }

    getRequest(selectedId) {
        return {
            AccountId: selectedId
        }
    }

    saveRequest() {
        return {
            accountId: this.props.selectedId,
            accountName: this.state.form.accountName,
            description: this.state.form.description,
            stateCode: this.state.form.stateCode,
            state: this.state.form.state,
            countryCode: this.state.form.countryCode,
            country: this.state.form.country,
            address: this.state.form.address,
            city: this.state.form.city,
            zip: this.state.form.zip,
            active: this.state.form.active,
            statusId: this.state.form.statusId,
            rowVersion: this.state.form.rowVersion
        }
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={8}>
                        <FormGroup>
                            <Label htmlFor="accountName" required>Account Name</Label>
                            <TextBox name="accountName" maxLength={50} required ref={(c) => { this.focusControl = c; }} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="description" >Description</Label>
                            <TextBox name="description" maxLength={128} />
                            <CheckBox name="active" label="Active" />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Address name="address" />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default AccountInfoTab;


// WEBPACK FOOTER //
// ./src/areas/admin/accountSetup/accountInfo/AccountInfoTab.js